<div class="main-container" id="main-container" >
    <div class="main" id="main" #main>
        <router-outlet></router-outlet>
    </div>
</div>
